import { useEffect, useState } from "react";
import { BpmService } from "../../../core/services/BpmService";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";
import { Modal } from "../../theme/Component/Modal";
import { RenderInbox } from "./RenderInbox";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { CardTaps } from "../../theme/Component/CardTaps";
import { CardTramitesHistory } from "../config/InfoTramiteComponents/HistoryImp/CardTramitesHistory";
import { PrintJson } from "../../theme/Component/PrintJson";
import { NotesImp } from "../config/InfoTramiteComponents/NotesImp/NotesImp";
import { ResumeImp } from "../config/InfoTramiteComponents/ResumeImp/ResumeImp";

interface Props {
    Procedure: { IDProcedureImp: number };
    requestLista: Function;
    _idAccount?: number;
}

interface ModalButton {
    isEnable: boolean;
    setEnable: any;
}

export const ProcedureActionInbox = ({ Procedure, requestLista, _idAccount }: Props) => {

    const service = new BpmService();
    const single = Singleton.getInstance();
    const [action, setAction] = useState<any>({});
    const [lista, setLista] = useState([]);
    const [modalAction, setModalAction] = useState<any>({ name: 'Documentos requeridos', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });

    useEffect(() => {
        setTimeout(() => {
            getLista();
        }, 50)
    }, [Procedure])

    useEffect(() => {
        if (action.IDAction > 0)
            setModalAction({ ...modalAction, "view": true });
    }, [action.IDAction])

    const getLista = () => {
        single.spinner(true);
        service.getProcedureActionByAccount(_idAccount ?? single.getAccountID(), Procedure.IDProcedureImp).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue.length > 0) {
                    setLista(resp.DataBeanProperties.ObjectValue)
                    ////console.log(resp.DataBeanProperties.ObjectValue)
                } else {
                    requestLista();
                    toast.success("sin acciones pendientes");
                }
                single.spinner(false)
            }
        )
    }

    const taps = [
        { id: 0, name: 'Gestión' },
        { id: 1, name: 'Resumen' },
        { id: 2, name: 'Notas' },
        { id: 3, name: 'Historial' },
    ]

    const [indexTap, setIndexTap] = useState(0);

    return (
        <>
            {lista.length > 0 ?
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Pendiente</th>
                            <th scope="col">Estado</th>
                            <th scope="col">Tarea</th>
                            <th scope="col">Fecha</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lista &&
                            <>
                                {lista.map((e: any, i: number) =>
                                    <tr key={i} >
                                        <th scope="row">{e.DataBeanProperties.Name}</th>
                                        <td><strong>{e.DataBeanProperties.StateName}</strong></td>
                                        <td>{e.DataBeanProperties.ProcedureName}</td>
                                        <td>{e.DataBeanProperties.Since}</td>
                                        <td>
                                            <div className="d-flex justify-content-center gap-2 mt-3 fs-2 text-warning">
                                                <FaCheckCircle title='Gestionar' className="pointer" onClick={() => { setAction(e.DataBeanProperties); setModalAction({ ...modalAction, "view": true }) }} />
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </>
                        }
                    </tbody>
                </table>
                :
                <div className='border rounded p-5 text-justify'>
                    <p>
                        Estimado usuario usted NO tiene acciones pendientes por gestionar en
                        esta solicitud.
                        <br />
                        <br />
                        Si el estado de su solicitud está <strong className='text-primary'>EN PROGRESO</strong> debe esperar
                        a que las próximas actualizaciones le sean notificadas.
                    </p>
                </div>
            }

            <Modal modal={modalAction} updateModal={setModalAction} evenOnClose={() => { getLista(); console.log("cerrando modal") }}>
                <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap} >
                    <div className="row">
                        <div className="col-md-12">
                            {indexTap === 0 &&
                                <RenderInbox procedure={Procedure} key={action.IDAction} action={action} requestListAction={() => { getLista(); setModalAction({ ...modalAction, "view": false }); }} />
                            }
                            {indexTap === 1 &&
                                <ResumeImp IDProcedureImp={Procedure.IDProcedureImp} />
                            }
                            {indexTap === 2 &&
                                <NotesImp Action={action} />
                            }
                            {indexTap === 3 &&
                                <CardTramitesHistory ID={Procedure.IDProcedureImp} />
                            }
                        </div>
                    </div>
                </CardTaps>
            </Modal>
        </>
    )
}